<template>
    <v-simple-table>
        <template v-slot:default>
            <thead>
                <tr>
                    <th class="text-left">Имя</th>
                    <th class="text-left">Роль</th>
                    <th class="text-left">Статус</th>
                    <th class="text-left">Пароль</th>
                    <th class="text-left"></th>
                </tr>
            </thead>
            <tbody>
                <User v-for="user in get_users" :key="user._id" :user="user" />
            </tbody>
        </template>
    </v-simple-table>
</template>
        


<script>
// import ProductOriginal from '@/components/ProductOriginal.vue'
// import User from '@/components/User.vue'
// import CreateProduct from '@/components/CreateProduct.vue'

import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'

import User from './User'

export default {
    name: 'UserList',
    data() {
        return {}
    },
    components: {
        User,
    },
    created() {
        this.load_users()
    },
    computed: {
        ...mapGetters(['get_users']),
    },
    methods: {
        ...mapActions(['load_users']),
    },
}
</script>